export type SarDebugRecordsRequestPayloadSource = {
    file_id?: string;
    file_group_id?: string;
    workflow_id?: string;
    step_name?: string;
    record_type?: string;
    page?: number;
    page_size?: number;
};

export function buildSarDebugRecordsRequestData(params: SarDebugRecordsRequestPayloadSource) {
    return {
        file_id: params.file_id,
        file_group_id: params.file_group_id,
        workflow_id: params.workflow_id,
        step_name: params.step_name,
        record_type: params.record_type,
        page: params.page,
        page_size: params.page_size,
    };
}
